import React from 'react';
import { useSelector } from 'react-redux';

import H5 from '@styled/Elements/H5';

import Description from '../components/Description';
import Section from '../components/Section';

export default function PersonalInfo() {
  const userFullName = useSelector((state) => { return state.auth.user?.username});

  return (
    <Section>
      <Description>
        <H5>Account</H5>
      </Description>
      <div>{userFullName}</div>
    </Section>
  );
}
